<template>
  <div class="press-index">
    <div class="press-index__list">
      <a
        v-for="(item, i) in Array.isArray(blocks) ? blocks : []"
        :key="(item?.id ?? item?.publication ?? 'press') + '-' + i"
        class="press-index__row"
        :href="item?.url || '#'"
        :aria-disabled="!item?.url"
        target="_blank"
        rel="noopener"
      >
        <!-- Hover thumbnail -->
        <figure class="press-index__thumb" aria-hidden="true">
          <img v-if="item?.imageUrl" :src="item.imageUrl" :alt="item?.imageAlt || ''" />
        </figure>

        <!-- Publication -->
        <div class="press-index__pub">
          {{ item?.publication || '' }}
        </div>

        <!-- Excerpt + READ ARTICLE on hover -->
        <div class="press-index__excerpt">
          <div class="press-index__excerpt-text">
            {{ item?.excerpt || '' }}
          </div>
          <div class="press-index__cta" aria-hidden="true">READ ARTICLE</div>
        </div>

        <!-- Date (only render if we have at least month or year) -->
        <div v-if="item?.month || item?.year" class="press-index__date">
          (&nbsp;{{ item?.month || '' }}&nbsp;‘{{ twoDigit(item?.year) }}&nbsp;)
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
type PressItem = {
  publication?: string
  excerpt?: string
  month?: string
  year?: string
  url?: string
  imageUrl?: string
  imageAlt?: string
  id?: string | number
}

const props = defineProps<{ blocks: PressItem[] }>()

function twoDigit(val?: string) {
  const s = (val ?? '').toString().trim()
  return s ? s.slice(-2) : ''
}
</script>

<style lang="scss">
@import '~styles/base.scss';
@import '~styles/legacy.scss';

.page-press-index .page-title,
.page--press-index .page-title,
.template-page.page-press-index .page-title {
  display: none !important;
}

.page-template-press {
  .page-template-container__title {
    text-align: center;
    padding-bottom: 80px;
    h1 {
      @include type-xl;
      @include uppercase;
    }
  }

  &__content {
    display: grid;
    margin-left: columns(4);
    margin-right: columns(4);
    grid-template-columns: columns(8) 1fr columns(10);

    @include breakpoint(m) {
      margin-left: columns(2);
      margin-right: columns(2);
      grid-template-columns: columns(10) 1fr columns(10);
    }

    @include breakpoint(xxs) {
      margin-left: auto;
      margin-right: auto;
      grid-template-columns: 1fr;
    }
  }

  &__list {
    @include breakpoint(xxs) {
      text-align: center;
    }
  }

  &__item {
    @include serif;
    @include type-m;
    @include helper-link-underline;
    padding-bottom: 10px;
    cursor: pointer;
    + * {
      padding-top: 10px;
    }
  }

  &__link {
    @include breakpoint(xxs) {
      text-align: center;
    }
    span {
      // text-decoration:underline;
      font-style: italic;
      transition: opacity 0.2s;
      opacity: 0;
    }
    &:focus,
    &:hover {
      span {
        opacity: 1;
      }
    }
  }

  &__preview {
    grid-column: -2 / -1;

    @include breakpoint(xxs) {
      display: none;
    }
  }

  &__images {
    position: sticky;
    top: 160px;
    display: grid;
  }

  &__image {
    grid-column: 1/-1;
    grid-row: 1/-1;
    opacity: 0;
    transition: opacity 0.2s ease;
    img {
      width: 100%;
      max-width: none;
    }

    &--active {
      opacity: 1;
    }
  }
}
</style>
